import { Avatar, Card, Paper, Skeleton, Text } from "@mantine/core"

export interface ReportCardData {
  title: string
  description?: string
  count?: number | string
  icon: any
  loading?: boolean
  key?: number
  obj?: any
  onClick?: () => void
}

export function formatCurrency(val: number) {
  return val?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const ReportCard: React.FC<ReportCardData> = (props: ReportCardData) => {
  return (
    <div className="col-span-6 md:col-span-4 lg:col-span-3 ">
      <Card
        shadow="sm"
        radius="md"
        withBorder
        className="shadow-lg hover:shadow-xl"
      >
        <Paper className="">
          <Text className="text-gray-600">{props.title}</Text>
        </Paper>

        <Paper className="flex items-center justify-between space-x-3 mt-2">
          <Avatar
            color="blue"
            radius="sm"
            // size={"sm"}
            className="text-gray-500"
          >
            {" "}
            {props.icon}
          </Avatar>
          <Text className="text-2xl font-medium">
            <Skeleton height={50} circle visible={props?.loading}>
              <Text> {props.count ?? "--"}</Text>
            </Skeleton>
          </Text>
        </Paper>
      </Card>
    </div>
  )
}
